<ng-container *transloco="let t; read: 'employee'">
  <ng-container *ngIf="vm$ | async as vm">
    <h2>{{ t('roles') }}</h2>

    <form 
        [formGroup]="form"
        (ngSubmit)="onSubmit(vm.employee)"
    >
    <div formArrayName="userRoles" class="mbs">
        <div *ngFor="let userRole of userRolesArray.controls; let i=index">
          <div [formGroupName]="i">

            <kendo-textbox
            [style.width.px]="200"
            [readonly]="true"
            [value]="userRole.roleName"
            formControlName="roleName"
            >
            </kendo-textbox>

            <kendo-textbox
            [style.width.px]="200"
            [readonly]="true"
            [value]="userRole.description"
            formControlName="description"
            >
            </kendo-textbox>

            <input 
                type="checkbox" 
                kendoCheckBox 
                formControlName="enabled"
                [value]="userRole.enabled"
            />
          </div>
        </div>
      </div>
      <button 
        kendoButton
        fillMode="solid"
        size="medium"
        rounded="large"
        themeColor="primary"
        type="submit"
        [disabled]="!form?.dirty"
      >Speichern</button>
    </form>
  </ng-container>
</ng-container>